import { capitalCase } from 'change-case';

import Model from '@/models/Model.js';

export default class Status extends Model {
    static entity = 'statuses';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            reason: this.attr(null),
            model_id: this.attr(null),
            model_type: this.attr(null),
            model_type_entity: this.attr(null),

            ...super.fields(),

            model: this.morphTo('model_id', 'model_type'),
        };
    }

    get fluent_reason() {
        if (this.reason) {
            return `${capitalCase(this.name)} ${this.reason}`;
        }

        return capitalCase(this.name);
    }
}
